import React, { Fragment } from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';

const VocationJuniorInterestAreaDescriptionPage = ({
  background,
  number,
  electivos,
  campaign
}) => {
  const AREA_A = electivos && electivos?.find(e => e.id === 'A');
  const AREA_B = electivos && electivos?.find(e => e.id === 'B');
  const AREA_C = electivos && electivos?.find(e => e.id === 'C');
  const A_IS_AVAILABLE = AREA_A ? AREA_A?.available : true; // defaults to true if no electivos
  const B_IS_AVAILABLE = AREA_B ? AREA_B?.available : true; // defaults to true if no electivos
  const C_IS_AVAILABLE = AREA_C ? AREA_C?.available : true; // defaults to true if no electivos
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          {A_IS_AVAILABLE && (
            <Fragment>
              <h3>3.1.1. Área A</h3>
              <p className='justified'>
                Esta área agrupa los dominios tradicionalmente asociados a las{' '}
                <strong>
                  Ciencias Sociales y Humanidades, como la Filosofía, Historia,
                  Geografía, Lenguaje, Literatura
                </strong>
                . Las personas interesadas en esta área generalmente disfrutan
                del análisis crítico y discusión sobre obras literarias, eventos
                históricos relevantes, dilemas filosóficos, etc. Pueden tener
                interés en profundizar en temas de la sociedad, como la
                política, economía o desarrollo. También pueden disfrutar de la
                expresión escrita, creativa o informativa.
              </p>
              {AREA_A?.customCourses && (
                <p className='justified'>
                  {campaign?.organization ?? 'Establecimiento'} tiene a
                  disposición los siguientes cursos electivos para esta área:{' '}
                  {AREA_A?.customCourses
                    ?.split('\n')
                    .reduce((acc, curr, index) => {
                      let currItem = curr;
                      // joiner, if penultimate, add ' y '
                      if (
                        index ===
                        AREA_A?.customCourses?.split('\n').length - 2
                      ) {
                        currItem += ' y ';
                      } else if (
                        index <
                        AREA_A?.customCourses?.split('\n').length - 2
                      ) {
                        currItem += ', ';
                      }
                      return `${acc}${currItem}`;
                    }, '')}
                  .
                </p>
              )}
            </Fragment>
          )}
          {B_IS_AVAILABLE && (
            <Fragment>
              <h3>3.1.{A_IS_AVAILABLE ? '2' : '1'}. Área B</h3>
              <p className='justified'>
                Se agrupan aquí las áreas de conocimiento relacionadas con las{' '}
                <strong>
                  Ciencias Exactas, como la Química o la Matemática, Ciencias
                  Biológicas y Ciencias de la Salud
                </strong>
                . Las personas interesadas en esta área generalmente disfrutan
                de la investigación y experimentación científica, aprender sobre
                los seres vivos, sobre los fenómenos químicos o físicos. Pueden
                tener interés además en el análisis de datos o la resolución de
                problemas matemáticos. También pueden disfrutar de temas de
                computación, tecnología y desarrollo de software.
              </p>
              {AREA_B?.customCourses && (
                <p className='justified'>
                  {campaign?.organization ?? 'Establecimiento'} tiene a
                  disposición los siguientes cursos electivos para esta área:{' '}
                  {AREA_B?.customCourses
                    ?.split('\n')
                    .reduce((acc, curr, index) => {
                      let currItem = curr;
                      // joiner, if penultimate, add ' y '
                      if (
                        index ===
                        AREA_B?.customCourses?.split('\n').length - 2
                      ) {
                        currItem += ' y ';
                      } else if (
                        index <
                        AREA_B?.customCourses?.split('\n').length - 2
                      ) {
                        currItem += ', ';
                      }
                      return `${acc}${currItem}`;
                    }, '')}
                  .
                </p>
              )}
            </Fragment>
          )}
          {C_IS_AVAILABLE && (
            <Fragment>
              <h3>3.1.{B_IS_AVAILABLE ? '3' : '2'}. Área C</h3>
              <p className='justified'>
                Esta área agrupa por una parte a las disciplinas relacionadas
                con las{' '}
                <strong>
                  Artes, la Arquitectura y la Música, y por otra aquellas
                  disciplinas relacionadas con las Ciencias del Deporte
                </strong>
                . Las personas interesadas en esta área pueden disfrutar
                analizando y discutiendo sobre una obra artística, ya sea
                visual, musical, teatral, o bien les atrae la creación de una
                obra artística propia. Pueden también tener intereses en el
                diseño de objetos o la arquitectura. Por otra parte, pueden
                disfrutar de la realización de deportes, de aprender cómo
                funciona el cuerpo humano durante el ejercicio, y cómo
                desarrollar estilos de vida más saludables.
              </p>
              {AREA_C?.customCourses && (
                <p className='justified'>
                  {campaign?.organization ?? 'Establecimiento'} tiene a
                  disposición los siguientes cursos electivos para esta área:{' '}
                  {AREA_C?.customCourses
                    ?.split('\n')
                    .reduce((acc, curr, index) => {
                      let currItem = curr;
                      // joiner, if penultimate, add ' y '
                      if (
                        index ===
                        AREA_C?.customCourses?.split('\n').length - 2
                      ) {
                        currItem += ' y ';
                      } else if (
                        index <
                        AREA_C?.customCourses?.split('\n').length - 2
                      ) {
                        currItem += ', ';
                      }
                      return `${acc}${currItem}`;
                    }, '')}
                  .
                </p>
              )}
            </Fragment>
          )}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationJuniorInterestAreaDescriptionPage;
